import { deliveryRecord, deliveryRecordVerifyAccend, deliveryRecordCancelVerifyAccend } from '@/api/index'

export function DeliveryRecordIndex (data) {
  return deliveryRecord.request({
    method: 'post',
    url: '/Index',
    data
  })
}
export function DeliveryRecordPushWb (data) {
  return deliveryRecord.request({
    method: 'post',
    url: '/PushWb',
    data
  })
}
export function VerifyAccend (data) {
  return deliveryRecordVerifyAccend.request({
    method: 'post',
    url: '',
    data
  })
}
export function CancelVerifyAccend (data) {
  return deliveryRecordCancelVerifyAccend.request({
    method: 'post',
    url: '',
    data
  })
}

export function SaveAdrr (data) {
  return deliveryRecord.request({
    method: 'post',
    url: '/SaveAdrr',
    data
  })
}

// export function getIntervalNoAll (data, params) {
//   const extendUrl = params.urlParam ? '?' + params.urlParam : ''
//   return deliveryRecord.request({
//     method: 'post',
//     url: '/GetintervalNoAll' + extendUrl,
//     data
//   })
// }
